<template>
  <div class="product-chart">
    <page-title :label="$t('product_dashboard_main.title_scatter_plot')" :iconPath="iconPath" />
    <emission-filter
      v-if="isLoading"
      v-model="dataFilter"
      :branchIds="branchIds"
      :isHasBranchNull="isHasBranchNull"
      :productList="productList"
      :categoryList="categoryList"
      :isBubble="true"
      @onChangeSelectedData="handleSelectedDataChange"
      @onChangeFilterType="handleFilterChange"
      @onChangeFilterOptions="handleChangeFilterOptions"
    />
    <div class="tabs-header">
      <tab-header :tab="selectedTab" @update:tab="handleUpdateTab" />
    </div>
    <div class="button-action" :class="{ 'button-action-tab': selectedTab === 1 }">
      <div class="tab-year-select" v-if="selectedTab === 0">
        <v-select
          solo
          flat
          :items="getYearList"
          v-model="curentYear"
          @change="handleGetDataChartUpdatedByYear(curentYear)"
          :label="$t('dashboard_main.placeholder_select_item_label')"
          item-text="value"
          item-value="value"
          class="select-type select-default select-types list-menu--select select-item durations-select-item mt-0"
          :menu-props="{ contentClass: 'select-menu product-select' }"
        />
      </div>
      <div v-else class="filter-durations">
        <filter-duration
          :startMonthProps="startMonthProps"
          :durationsSelectedData="durationsSelectedData"
          @filterUpdated="handleGetDataChartUpdated"
          :tab="selectedTab"
        />
      </div>
      <div v-if="isShowButton" class="button-setting">
        <button-custome
          icon="set-scatter-plot.svg"
          iconHover="set-scatter-plot-hover.svg"
          iconDisable="addregistericon_disabled.svg"
          typeIcon="icons"
          :isSmallButton="true"
          :buttonText="$t('bubble_chart.button_scatter_plot_setting')"
          class="boundary-btn"
          @action="openScatterPlotSettingDialog"
        >
        </button-custome>
        <button-custome
          icon="eye.svg"
          iconHover="eye-hover.svg"
          iconDisable="addregistericon_disabled.svg"
          typeIcon="icons"
          :isSmallButton="true"
          :buttonText="$t('bubble_chart.button_bubble_chart_color')"
          class="boundary-btn"
          @action="hanldeStatusHighlight(true)"
        >
        </button-custome>
      </div>
    </div>
    <div class="tabs-content">
      <chart-bubble
        @updateSelectedData="handleUpdateSelectedData"
        :axisConfigData="axisConfigData"
        :colorConfig="colorConfigData"
        :filterType="dataFilter.filterType"
        :dataChartProp="dataChart"
        :productsByCategory="productsByCategory"
        :xAxisKey="xAxisKey"
        :yAxisKey="yAxisKey"
        :bubbleSizeKey="bubbleSizeKey"
      />
    </div>
    <setting-bubble-chart-color
      :dialog="isShowHightlight"
      :labelSelect="$t('bubble_chart.popup_please_select_product')"
      :filterType="dataFilter.filterType"
      :colorConfig="colorConfigData"
      :confirmText="$t('product_dashboard_main.button_decision')"
      :dataList="selectedOptions"
      @close="hanldeStatusHighlight(false)"
      @onHighlightSubmit="handleSettingColorConfig"
    ></setting-bubble-chart-color>
    <scatter-plot-setting-dialog
      :dialog="openPopupScaretPlot"
      :title="$t('bubble_chart.button_scatter_plot_setting')"
      :confirmText="$t('product_dashboard_main.button_decision')"
      confirmBtnClass="colored"
      :currentYear="monthYearData"
      :selectedTab="selectedTab"
      :axisConfigData="axisConfigData"
      @submit="handleConfirmScatterPlotSetting"
      @close="closeSettingDialog"
    />
  </div>
</template>

<script>
import settingBubbleChartColor from '@/components/dialogs/setting-bubble-chart-color.vue';
import { mapActions, mapState } from 'vuex';
import ChartBubble from '@/components/products/charts/period/bubble-chart/chart-data.vue';
import PageTitle from '@/components/products/common/page-title.vue';
import { PRODUCT_DASHBOARD } from '@/constants/products/define-data';
import FilterDuration from '@/components/products/charts/filter-duration/index.vue';
import TabHeader from '@/components/products/common/tab-header.vue';
import ScatterPlotSettingDialog from '@/components/dialogs/scatter-plot-setting-dialog.vue';
import ButtonCustome from '@/components/commonApp/ButtonIconCustom';
import EmissionFilter from '@/components/products/common/emission-filter.vue';
import { GHG_PER_PRODUCT } from '@/constants/ghg-per-product';
import { getFieldNameDashboardProduct } from '@/utils/new-cfp-dashboard';
import { ghgPerProductDashboardGeneral } from '@/api/product/emissionsProduct';
export default {
  components: {
    PageTitle,
    ChartBubble,
    FilterDuration,
    TabHeader,
    ButtonCustome,
    settingBubbleChartColor,
    EmissionFilter,
    ScatterPlotSettingDialog,
  },
  props: {
    branchIds: {
      type: Array,
      default: () => [],
    },
    productList: {
      type: Array,
      default: () => [],
    },
    categoryList: {
      type: Array,
      default: () => [],
    },
    isHasBranchNull: {
      type: Boolean,
      default: false,
    },
    startMonthProps: {
      type: Number,
      default: 0,
    },
    yearList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedTab: 0,
      iconPath: 'dashboard/icon-ghg-bubble.svg',
      productsMasterList: [],
      isShowBubbleDisableSelected: true,
      filterUpdatedKeys: 0,
      durationsSelectedData: {},
      curentYear: null,
      isShowHightlight: false,
      dataFilter: {
        filterType: 1,
        selectedData: [],
      },
      openPopupScaretPlot: false,
      dialog: false,
      axisConfigData: {},
      colorConfigData: {},
      dataChart: [],
      productsByCategory: [],
      monthYearData: {
        month: null,
        year: null,
      },
      xAxisKey: 'xAxisData',
      yAxisKey: 'yAxisData',
      bubbleSizeKey: 'bubbleSizeData',
      filterOptions: [],
      selectedOptions: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapState('product', ['newDashboard']),
    getYearList() {
      let yearList = [...this.yearList];
      if (this.startMonthProps > 1) {
        yearList.shift();
      }
      return yearList;
    },
    getListProductId() {
      const realProductList = this.productList.filter((item) => item.id);
      const mapProductListData = (list) => list.map((item) => item.id);

      if (this.productsMasterList.length > 0) {
        // has selected products

        // filter products selected matching pulldown current
        const realProductListSelected = realProductList.filter((item) => this.productsMasterList.includes(item.id));

        if (realProductListSelected.length > 0) {
          return mapProductListData(realProductListSelected);
        }
      }
      return mapProductListData(realProductList); // don't selected products
    },
    isShowButton() {
      return window.location.pathname === '/product-emission/dashboard';
    },
  },
  created() {
    this.selectedTab = this.newDashboard.emissionsPerProducts.selectedType || 0;
    this.productsMasterList = this.newDashboard.emissionsPerProducts.productMasterIds;
    this.isShowBubbleDisableSelected = this.newDashboard.emissionsPerProducts.isGetAllProduct === false ? false : true;
    this.updateSelectedDurationStore();
    this.selectedFirstItem();
  },
  methods: {
    ...mapActions('product', ['updateNewEmissionsPerProducts', 'updateSettingBubble']),
    handleUpdateTab(newTab) {
      this.selectedTab = newTab;
      this.getDataToRenderBubble();
      if (newTab === 0) {
        this.monthYearData = {
          month: null,
          year: this.curentYear,
        };
      } else {
        const monthInt = parseInt(this.durationsSelectedData.selectedMonthYear.start_at.slice(-2)); // lấy tháng ('YYYY-MM')
        this.monthYearData = {
          month: monthInt,
          year: this.durationsSelectedData.selectedMonthYear.year,
        };
      }
      this.updateDataToStore();
      this.selectedFirstItem();
    },
    getDataByKey(key, unit, item) {
      if (key === GHG_PER_PRODUCT.PRODUCT_QUANTITY || key === GHG_PER_PRODUCT.ANNUAL_PRODUCT) {
        return Number(item[key]);
      } else {
        return Number(item[`${key}-${unit}`]);
      }
    },
    convertKeyToRender(dataChart) {
      const { horizontalAxis, bubbleSize, verticalAxis } = this.axisConfigData || {};
      const xDataKey = horizontalAxis?.topic;
      const xUnit = horizontalAxis?.unit?.key;
      const yDataKey = verticalAxis?.topic;
      const yUnit = verticalAxis?.unit?.key;
      const bubbleSizeKey = bubbleSize?.topic;
      const bubbleSizeUnit = bubbleSize?.unit?.key;
      if (dataChart?.length) {
        return dataChart.map((item) => {
          const xAxisData = this.getDataByKey(xDataKey, xUnit, item);
          const yAxisData = this.getDataByKey(yDataKey, yUnit, item);
          const bubbleSizeData = this.getDataByKey(bubbleSizeKey, bubbleSizeUnit, item);
          return {
            ...item,
            [this.yAxisKey]: yAxisData,
            [this.xAxisKey]: xAxisData,
            [this.bubbleSizeKey]: Math.abs(bubbleSizeData), // use abs for setting bubbleSizeKey alway positive number
            actualBubbleSizeData: bubbleSizeData, // use for display bubble size in tooltip
          };
        });
      }
      return [];
    },
    async getDataByFilterType(payload) {
      const { ox, oy, size } = payload;

      if (!ox?.key || !oy?.key || !size?.key || !ox?.unit || !oy?.unit || !size?.unit) {
        this.dataChart = [];
        return;
      }

      const selectedData = [...(this.dataFilter.selectedData || [])];
      const isProductFilter = this.dataFilter.filterType === 1;

      if (isProductFilter) {
        const keyProduct = getFieldNameDashboardProduct().payload_product_name;
        Object.assign(payload, {
          [keyProduct]: selectedData,
          branch_id: this.branchIds,
          branch_null: this.isHasBranchNull ? 1 : null,
        });
      } else {
        Object.assign(payload, {
          cfp_categories: selectedData,
          chart_type: 1,
          branch_id: this.branchIds,
          branch_null: this.isHasBranchNull ? 1 : null,
        });
      }

      const res = await ghgPerProductDashboardGeneral(payload, this.$route);

      if (Object.keys(res).length) {
        const dataChart = isProductFilter
          ? res.product_master || []
          : res.category_master
          ? Object.values(res.category_master)
          : [];

        this.dataChart = this.convertKeyToRender(dataChart);
      }
    },
    getParamsDurationOfStore() {
      let paramsStore = {};
      switch (this.selectedTab) {
        case 0: {
          const currentYear =
            this.currentYear || this.newDashboard.emissionsPerProducts?.selectedData?.selectedYear?.year;
          paramsStore.year = currentYear;
          break;
        }
        case 1: {
          const oldMonthYearSelected = this.newDashboard.emissionsPerProducts?.selectedData?.selectedMonthYear;
          const [oldYear, oldMonth] = oldMonthYearSelected?.selected_range?.split('/');
          paramsStore.month = parseInt(oldMonth);
          paramsStore.year = oldYear;
          break;
        }
        default:
          paramsStore.year = this.newDashboard.emissionsPerProducts?.selectedData?.selectedYear?.year;
          break;
      }
      return paramsStore;
    },
    getDataToRenderBubble(params = {}) {
      let payload = {
        type: this.selectedTab,
        ox: {
          key: this.axisConfigData?.horizontalAxis?.topic,
          unit: this.axisConfigData?.horizontalAxis?.unit?.key,
        },
        oy: {
          key: this.axisConfigData?.verticalAxis?.topic,
          unit: this.axisConfigData?.verticalAxis?.unit?.key,
        },
        size: {
          key: this.axisConfigData?.bubbleSize?.topic,
          unit: this.axisConfigData?.bubbleSize?.unit?.key,
        },
        ...this.getParamsDurationOfStore(),
        ...params,
      };
      //apply data to store
      this.updateDataToStore();
      this.getDataByFilterType(payload);
    },
    selectedFirstItem() {
      let index = -1;
      const oldYearSelected = this.durationsSelectedData?.selectedYear;
      index = this.getYearList.findIndex((item) => item?.value === oldYearSelected?.year);
      if (index < 0) {
        index = 0; // current FY
      }
      this.curentYear = this.getYearList[index]?.value;
      if (this.selectedTab === 0) {
        this.monthYearData = {
          month: null,
          year: this.getYearList[index]?.value,
        }
      } else {
        const monthInt = parseInt(this.durationsSelectedData.selectedMonthYear.start_at.slice(-2)) // lấy tháng ('YYYY-MM')
        this.monthYearData = {
          month: monthInt,
          year: this.durationsSelectedData.selectedMonthYear.year
        };
      }
      this.updateDataToStore();
    },
    updateSelectedDurationStore() {
      this.durationsSelectedData = {
        selectedYear: this.newDashboard.emissionsPerProducts?.selectedData?.selectedYear,
        selectedHalfYear: this.newDashboard.emissionsPerProducts?.selectedData?.selectedHalfYear,
        selectedQuarterYear: this.newDashboard.emissionsPerProducts?.selectedData?.selectedQuarterYear,
        selectedMonthYear: this.newDashboard.emissionsPerProducts?.selectedData?.selectedMonthYear,
      };
    },
    handleGetDataChartUpdatedByYear(year) {
      this.monthYearData = {
        month: null,
        year: year
      }
      this.updateNewEmissionsPerProducts({
        ...this.newDashboard.emissionsPerProducts,
        selectedData: {
          ...this.newDashboard.emissionsPerProducts.selectedData,
          selectedYear: { year: year },
        },
      });
      this.filterUpdatedKeys++;
      this.getDataToRenderBubble();
    },
    handleGetDataChartUpdated(store) {
      const monthInt = parseInt(store.selectedMonthYear.start_at.slice(-2)) // lấy tháng ('YYYY-MM')
      this.monthYearData = {
        month: monthInt,
        year: store.selectedMonthYear.year
      }
      this.updateNewEmissionsPerProducts({
        ...this.newDashboard.emissionsPerProducts,
        selectedData: {
          ...this.newDashboard.emissionsPerProducts.selectedData,
          ...store,
        },
      });
      this.filterUpdatedKeys++;
      this.getDataToRenderBubble();
    },
    handleSelectProductsMaster(value) {
      this.productsMasterList = value;
      this.updateDataToStore();
    },
    updateDataToStore() {
      if (this.isShowBubbleDisableSelected) {
        this.productsMasterList = [];
      }
      const selectedData = this.newDashboard.emissionsPerProducts.selectedData;
      this.updateNewEmissionsPerProducts({
        isGetAllProduct: this.isShowBubbleDisableSelected,
        productMasterIds: this.productsMasterList,
        selectedType: this.selectedTab,
        selectedData: {
          ...this.newDashboard.emissionsPerProducts.selectedData,
          duration_type_month_id: this.currentDurationMonthId,
          month: this.month || selectedData.month,
          yearTypeYear: this.selectedTab === 0 ? this.yearTypeYear : selectedData.yearTypeYear,
          yearTypeMonth: this.selectedTab === 0 ? selectedData.yearTypeMonth : this.yearTypeMonth,
          selectedYear: { year: this.curentYear },
        },
      });
    },
    updateSelectedChart(value) {
      this.isShowBubbleDisableSelected = PRODUCT_DASHBOARD.GET_ALL_PRODUCT === value;
    },
    handleUpdateSelectedData(value) {
      this.selectedTab = value.selectedTab;
      if (this.selectedTab > 0) {
        this.month = value.month;
      }
      if (this.selectedTab === 0) {
        this.yearTypeYear = value.year;
      } else {
        this.yearTypeMonth = value.year;
      }
    },
    hanldeStatusHighlight(status) {
      this.isShowHightlight = status;
    },
    openScatterPlotSettingDialog() {
      this.openPopupScaretPlot = true;
    },
    handleConfirmScatterPlotSetting(data) {
      const axisConfig = { ...data };
      this.updateSettingBubble({ axisConfig });
      this.openPopupScaretPlot = false;
      this.axisConfigData = { ...axisConfig };
      this.getDataToRenderBubble();
    },
    closeSettingDialog() {
      this.openPopupScaretPlot = false;
    },
    submit() {
      this.dialog = !this.dialog;
    },
    handleSettingColorConfig(data) {
      this.isShowHightlight = false;
      this.colorConfigData = { ...this.colorConfigData, ...data };
    },
    handleSelectedDataChange(data) {
      const listType = this.dataFilter.filterType === 1 ? 'productFilterList' : 'categoryFilterList';
      const newData = {
        [listType]: data,
      };
      this.dataFilter = { ...this.dataFilter, selectedData: [...data] };

      if (data.length) {
        this.selectedOptions = [...this.filterOptions.filter(({ id }) => data.includes(id))];
      } else {
        this.selectedOptions = [...this.filterOptions];
      }

      this.getDataToRenderBubble();
      this.updateSettingBubble({ ...newData });
    },
    handleFilterChange(value) {
      this.updateSettingBubble({ filterType: value });
      const listType = value === 1 ? 'productFilterList' : 'categoryFilterList';
      const newData = {
        selectedData: [...(this.newDashboard.bubbleChartSetting?.[listType] || [])],
        filterType: value,
      };
      this.dataFilter = {
        ...newData,
      };
      this.getDataToRenderBubble();
    },
    handleClickOutSite() {
      this.close();
    },
    handleChangeFilterOptions(data) {
      this.filterOptions = [...data.slice(1)];
      if (this.dataFilter.selectedData.length) {
        this.selectedOptions = data.filter(({ id }) => this.dataFilter.selectedData.includes(id));
      } else {
        this.selectedOptions = [...data.slice(1)];
      }
    },
  },
  watch: {
    isShowBubbleDisableSelected: {
      handler() {
        this.updateDataToStore();
      },
      deep: true,
    },
    selectedTab: {
      handler() {
        this.updateSelectedDurationStore();
      },
    },
    productList: {
      handler(newData) {
        const optionIds = newData.map(({ id }) => id);
        const selectedProducts = [...(this.newDashboard.bubbleChartSetting?.['productFilterList'] || [])];
        const newSelectedData = selectedProducts.filter((id) => optionIds.includes(id));
        const updatedData = {
          productFilterList: newSelectedData,
        };
        this.updateSettingBubble({ ...updatedData });

        if (this.dataFilter.filterType === 1) {
          this.dataFilter.selectedData = [...newSelectedData];
          this.getDataToRenderBubble();
        }
      },
    },
    branchIds: {
      async handler() {
        if (this.dataFilter.filterType === 2) {
          await this.getDataToRenderBubble();
        }
      },
    },
  },
  mounted() {
    const filter = this.newDashboard.bubbleChartSetting.filterType || 1;
    const axisData = this.newDashboard.bubbleChartSetting.axisConfig;
    this.axisConfigData = { ...axisData };
    this.colorConfigData = this.newDashboard.bubbleChartSetting.colorConfig;
    const dataList =
      filter === 1
        ? [...(this.newDashboard.bubbleChartSetting.productFilterList || [])]
        : [...(this.newDashboard.bubbleChartSetting.categoryFilterList || [])];
    this.dataFilter = {
      filterType: filter,
      selectedData: [...(dataList || [])],
    };
    this.isLoading = true;
  },
};
</script>
<style lang="scss" scoped>
.product-chart {
  width: 100%;

  .tabs-header {
    margin-bottom: 16px;
  }

  .tabs-content {
    .theme--light.v-tabs-items {
      background-color: transparent;
    }
  }

  .product-filter_width {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 16px;
    margin-bottom: 48px;

    .product-filter {
      width: 288px;

      @include desktop {
        width: 240px;
      }
    }
  }
}

.period-combobox {
  width: 100%;
  margin-bottom: 48px;
}

.button-action {
  display: flex;
  gap: 10px;
  .tab-year-select {
    margin-bottom: 16px;
    @include desktop {
      width: 120px;
    }
  }
  .boundary-btn {
    display: flex;
    gap: 8px;
    border: none;
    padding: 0px 12px;
    height: 40px;
    box-shadow: 0px 36px 33px 0px rgba(160, 181, 186, 0.07), 0px 13.141px 12.046px 0px rgba(160, 181, 186, 0.11),
      0px 6.38px 5.848px 0px rgba(160, 181, 186, 0.13), 0px 3.127px 2.867px 0px rgba(160, 181, 186, 0.17),
      0px 1.237px 1.134px 0px rgba(160, 181, 186, 0.24);
  }

  .button-setting {
    display: flex;
    gap: 10px;
  }

  .filter-durations {
    .duration-wrapper {
      margin: 0px;
    }
  }

  &.button-action-tab {
    flex-direction: column;

    .button-setting {
      padding-bottom: 16px;
    }
  }
}

::v-deep {
  .emission-filter {
    padding: 16px 0;
    gap: 16px;
  }
  .boundary-btn {
    .icon-default {
      padding: 10px 0px;
      width: 20px;
    }
    .icon-hover {
      padding: 10px 0px;
      width: 20px;
    }
    .button-custom_text {
      padding: 8px 0px;
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0.03em;
    }
    
  }
}

::v-deep {
  @media only screen and (max-width: 768px) {
    .emission-filter {
      gap: 8px;

      .emission-filter-select {
        padding: 0;
      }
    }
    .button-action {
      display: flex;
      gap: 10px;
      .tab-year-select {
        width: 120px;
        margin-bottom: 16px;
      }
      .boundary-btn {
        padding: 8px 12px;
        height: 40px;

        .button-custom_text {
          display: none;
        }
      }
    }
  }
}

::v-deep {
  @media only screen and (max-width: 480px) {
    .button-action {
      .tab-year-select {
        width: 120px;
        padding-right: 0px;
      }

      .button-custom_text {
        display: none;
      }
    }
  }
}
</style>
